import React, { useEffect, useState } from "react";
import classes from "./SeriesDetail.module.css";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../Components/Navbar";
import BackgroundMovieLayout from "../Components/BackgroundMovieLayout";
import {
  useGetReviewsQuery,
  useGetSeriesDetailsQuery,
  useGetSeriesSeasonDetailsQuery,
  useGetWatchProvidersMutation,
} from "../Slices/httpSlice";
import { useAnimationControls ,motion} from "framer-motion";
import BottomNavbar from "../Components/BottomNavbar";
import NavbarMobile2 from "../Components/NavbarMobile2";
import SkeletonCardsGrid from "../Components/SkeletonCardsGrid";
import MediaDetails from "../Components/MediaDetails/MediaDetails";
import MediaSubTitle from "../Components/MediaDetails/MediaSubTitle";
import CardVideoPlayer from "../Components/MediaDetails/CardVideoPlayer";
import MediaImages from "../Components/MediaDetails/MediaImages";
import MediaCast from "../Components/MediaDetails/MediaCast";
import MediaEpisodes from "../Components/MediaDetails/MediaEpisodes";
import MediaReviews from "../Components/MediaDetails/MediaReviews";
import { toggleReviewModal } from "../Slices/reviewModalSlice";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import ReviewModal from "../Components/ReviewModal";
import MediaRecommendations from "../Components/MediaDetails/MediaRecommendations";
import ViewReviewModal from "../Components/ViewReviewModal";
import {
  closeViewReviewModal,
  openViewReviewModal,
} from "../Slices/viewReviewModalSlice";
import { toast } from "react-toastify";
import SearchModal from "../Components/SearchModal";
import WatchlistModal from "../Components/WatchlistModal";
import UserRatingsModal from "../Components/UserRatingsModal";
import ProfileModal from "../Components/ProfileModal";
import Drawer from "../Components/Drawer";
import MediaDetailsLoading from "../Components/MediaDetails/MediaDetailsLoading";
import { toggleWatchProvidersModal } from "../Slices/watchProvidersModalSlice";

const SeriesDetail = () => {
  const { seriesId } = useParams();

  const [windowWidth, setWindowWidth] = useState<number>(0);
  const [season, setSeason] = useState<number | null>(null);

  const [getWatchProvidersApi, { isLoading: watchProvidersLoading }] =
    useGetWatchProvidersMutation();

  const [watchProviders, setWatchProviders] = useState<any>({});
  const [watchProvidersLength, setWatchProvidersLength] = useState(0);
  const [wpLoading, setWpLoading] = useState(true);

  const fetchWatchProviders = async () => {
    setWpLoading(true);
    const response: any = await getWatchProvidersApi({
      id: seriesId,
      media_type: "tv",
    });
    setWpLoading(false);
    if (response?.error) {
      toast.error(
        response?.error?.data?.error?.error ||
          response?.error?.data?.error ||
          response?.error?.data ||
          response?.error?.message ||
          "Something Went Wrong!"
      );
    } else {
      setWatchProviders(response?.data?.result);
      setWatchProvidersLength(
        () =>
          (response?.data?.result?.ads?.length ?? 0) +
          (response?.data?.result?.flatrate?.length ?? 0) +
          (response?.data?.result?.rent?.length ?? 0) +
          (response?.data?.result?.buy?.length ?? 0)
      );
    }
  };

  useEffect(() => {
    fetchWatchProviders();
  }, [seriesId]);

  useEffect(() => {
    const updateConstraints = () => {
      setWindowWidth(window.innerWidth);
    };

    updateConstraints();
    window.addEventListener("resize", updateConstraints);

    return () => {
      window.removeEventListener("resize", updateConstraints);
    };
  }, []);

  const {
    data: seriesDetails,
    isFetching: seriesDetailsLoading,
    refetch: seriesDetailsRefetch,
    isError: seriesDetailsError,
  } = useGetSeriesDetailsQuery(seriesId);

  const {
    data: seasonData,
    isFetching: seasonLoading,
    refetch: seasonRefetch,
    isError: seasonError,
  } = useGetSeriesSeasonDetailsQuery(
    { seriesId: seriesId, season: season },
    {
      skip: season === null,
    }
  );

  useEffect(() => {
    if (seriesDetails) {
      if (seriesDetails?.result?.seasons.length > 0) {
        setSeason(seriesDetails?.result?.seasons[0]?.season_number);
      } else {
        setSeason(null);
      }
    }
  }, [seriesDetails]);

  useEffect(() => {
    if (season !== null) {
      seasonRefetch();
    }
  }, [season]);

  const controls = useAnimationControls();

  const [videoLeftConstraint, setVideoLeftConstraint] = useState(0);
  const [videoIndex, setVideoIndex] = useState(0);

  const updateLeft = () => {
    const maxIndex = seriesDetails?.result?.videos?.results.length - 1;
    if (videoIndex < maxIndex) {
      setVideoIndex((prevValue) => prevValue + 1);
      setVideoLeftConstraint((prevValue) => prevValue + 330);
    }
  };

  const updateRight = () => {
    if (videoIndex > 0) {
      setVideoIndex((prevValue) => prevValue - 1);
      setVideoLeftConstraint((prevValue) => prevValue - 330);
    }
  };

  useEffect(() => {
    controls.start({ x: -videoLeftConstraint });
  }, [videoIndex, videoLeftConstraint]);

  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    setStartPosition({ x: event.clientX, y: event.clientY });
    setIsDragging(false);
  };

  const handleMouseUp = (
    event: React.MouseEvent<HTMLButtonElement>,
    seasonNo: number
  ) => {
    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      setSeason(seasonNo);
    }
  };

  const handleMouseMove = () => {
    setIsDragging(true);
  };

  const {
    data: seriesReviews,
    isFetching: seriesReviewsLoading,
    refetch: seriesReviewsRefetch,
    isError: seriesReviewsError,
  } = useGetReviewsQuery({ media_id: seriesId, media_type: "tv" });

  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.userSlice);
  const navigate=useNavigate();
  const openReviewModal = () => {
    if (!user) {
      toast.info(
        "Oops! Please signin or signup to leave a review and share your thoughts."
      );

      navigate("/");
   
    } else {
      dispatch(toggleReviewModal());
    }
  };

  const handleMouseDown2 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setStartPosition({ x: event.clientX, y: event.clientY });
    setIsDragging(false);
  };

  const handleMouseUp2 = (
    event: React.MouseEvent<HTMLButtonElement>,
    reviewId: number
  ) => {
    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      dispatch(openViewReviewModal({ reviewId: reviewId }));
    }
  };

  const handleMouseMove2 = () => {
    setIsDragging(true);
  };

  const { watchProvidersModal } = useAppSelector(
    (state) => state.watchProvidersModalSlice
  );

  const variants = {
    hidden: {
      y: window.innerHeight * 0.7,
      display: "none",
    },
    visible: {
      y: 0,
      display: "block",
    },
  };

  const controls2 = useAnimationControls();

  useEffect(() => {
    if (watchProvidersModal) {
      controls2.start("visible");
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [watchProvidersModal]);

  const closeModal = () => {
    controls2.start("hidden");
    dispatch(toggleWatchProvidersModal());
  };

  return (
    <>
      {seriesDetailsLoading ? (
        <>
          <MediaDetailsLoading />
        </>
      ) : (
        <>
          <BackgroundMovieLayout
            windowWidth={windowWidth}
            backdropImage={seriesDetails?.result?.backdrop_path}
            // backdropImage={seriesDetails?.result?.poster_path}
          >
            {/* <MediaToolbar /> */}
            {/* <NavbarMobile /> */}
            <NavbarMobile2 />
            <Navbar activeLink={null} />

            <MediaDetails
              mediaType="tv"
              mediaDetails={seriesDetails}
              windowWidth={windowWidth}
              watchProviders={watchProviders}
              watchProvidersLength={watchProvidersLength}
              wpLoading={wpLoading}
            />

            {/* MEDIA VIDEOS SECTION  */}
            <div className={classes.section_drag_cards}>
              <MediaSubTitle
                title="Videos"
                length={seriesDetails?.result?.videos?.results?.length}
                type="videos"
                updateRight={updateRight}
                updateLeft={updateLeft}
              />
              <CardVideoPlayer
                controls={controls}
                mediaDetails={seriesDetails}
                videoLeftConstraint={videoLeftConstraint}
              />
            </div>

            {/* MEDIA IMAGES SECTION  */}
            <div className={classes.section_drag_cards}>
              <MediaSubTitle
                length={seriesDetails?.result?.images?.backdrops?.length}
                title="Photos"
              />
              <MediaImages
                mediaDetails={seriesDetails}
                windowWidth={windowWidth}
              />
            </div>

            {/* MEDIA CAST SECTION  */}
            <div className={classes.section_drag_cards}>
              <MediaSubTitle
                length={seriesDetails?.result?.credits?.cast?.length}
                title="Top Cast"
              />

              <MediaCast
                mediaDetails={seriesDetails}
                windowWidth={windowWidth}
              />
            </div>

            {/* SEASONS AND EPISODES SECTION... */}

            <div className={classes.section_drag_cards}>
              <MediaSubTitle
                title="Episodes"
                length={seriesDetails?.result?.number_of_episodes}
              />
              <MediaEpisodes
                mediaDetails={seriesDetails}
                season={season}
                seasonData={seasonData}
                seasonLoading={seasonLoading}
                windowWidth={windowWidth}
                handleMouseDown={handleMouseDown}
                handleMouseMove={handleMouseMove}
                handleMouseUp={handleMouseUp}
              />
            </div>

            {/* MEDIA REVIEW SECTION  */}
            {seriesReviewsLoading ? (
              <SkeletonCardsGrid />
            ) : (
              <div className={classes.section_drag_cards}>
                <div className={classes.section_cards}>
                  <MediaSubTitle
                    title="User Reviews"
                    length={seriesReviews?.result.length}
                    type="review"
                    openReviewModal={openReviewModal}
                  />

                  <MediaReviews
                    mediaReviews={seriesReviews}
                    windowWidth={windowWidth}
                    type="series"
                    handleMouseDown={handleMouseDown2}
                    handleMouseMove={handleMouseMove2}
                    handleMouseUp={handleMouseUp2}
                  />
                </div>
              </div>
            )}

            {/* MEDIA RECOMMENDATIONS SECTION  */}
            <div className={classes.section_drag_cards}>
              <div className={classes.section_cards}>
                <MediaSubTitle
                  title="Similar Series"
                  length={
                    seriesDetails?.result?.recommendations?.results.length
                  }
                />

                <MediaRecommendations
                  mediaDetails={seriesDetails}
                  windowWidth={windowWidth}
                  type="series"
                />
              </div>
            </div>
          </BackgroundMovieLayout>

          <ReviewModal
            windowWidth={windowWidth}
            mediaDetails={seriesDetails}
            mediaReviews={seriesReviews}
            mediaReviewsRefetch={seriesReviewsRefetch}
            media_id={seriesId}
            media_type="tv"
            media_name={
              seriesDetails?.result?.title ?? seriesDetails?.result?.name
            }
          />

          <ViewReviewModal
            windowWidth={windowWidth}
            mediaDetails={seriesDetails}
            mediaReviews={seriesReviews}
            media_type="tv"
            // handleMouseDown={handleMouseDown2}
            // handleMouseMove={handleMouseMove2}
            // handleMouseUp={handleMouseUp2}
          />

          <BottomNavbar />
          <SearchModal />
          <WatchlistModal />
          <UserRatingsModal />
          <ProfileModal />
          <Drawer />

          <motion.div
            className={classes.modal}
            variants={variants}
            initial="hidden"
            animate={controls2}
            transition={{
              duration: 0.1,
              type: "spring",
              //   damping: 10,
              damping: 20,
              stiffness: 100,
            }}
          >
            <div className={classes.modal_nav}>
              <button
                className={classes.close_btn}
                type="button"
                onClick={() => closeModal()}
              >
                <i className={`pi pi-times ${classes.close_icon}`} />
              </button>
            </div>

            <div className={classes.content}>
              {watchProviders?.ads && (
                <div className={classes.providers_wrapper}>
                  <p className={classes.bio_title}>Free To Watch</p>
                  <div className={classes.providers}>
                    {watchProviders?.ads?.map((dataItem: any, idx: number) => {
                      return (
                        <div className={classes.provider} key={idx}>
                          <div className={classes.image}>
                            <img
                              src={`https://media.themoviedb.org/t/p/original/${dataItem?.logo_path}`}
                              alt={dataItem?.provider_name}
                              className={classes.provider_img}
                            />
                          </div>
                          <p className={classes.bio}>
                            {dataItem?.provider_name}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {watchProviders?.flatrate && (
                <div className={classes.providers_wrapper}>
                  <p className={classes.bio_title}>Streaming</p>
                  <div className={classes.providers}>
                    {watchProviders?.flatrate?.map(
                      (dataItem: any, idx: number) => {
                        return (
                          <div className={classes.provider} key={idx}>
                            <div className={classes.image}>
                              <img
                                src={`https://media.themoviedb.org/t/p/original/${dataItem?.logo_path}`}
                                alt={dataItem?.provider_name}
                                className={classes.provider_img}
                              />
                            </div>
                            <p className={classes.bio}>
                              {dataItem?.provider_name}
                            </p>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              )}

              {watchProviders?.rent && (
                <div className={classes.providers_wrapper}>
                  <p className={classes.bio_title}>Rent</p>
                  <div className={classes.providers}>
                    {watchProviders?.rent?.map((dataItem: any, idx: number) => {
                      return (
                        <div className={classes.provider} key={idx}>
                          <div className={classes.image}>
                            <img
                              src={`https://media.themoviedb.org/t/p/original/${dataItem?.logo_path}`}
                              alt={dataItem?.provider_name}
                              className={classes.provider_img}
                            />
                          </div>
                          <p className={classes.bio}>
                            {dataItem?.provider_name}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {watchProviders?.buy && (
                <div className={classes.providers_wrapper}>
                  <p className={classes.bio_title}>Buy</p>
                  <div className={classes.providers}>
                    {watchProviders?.buy?.map((dataItem: any, idx: number) => {
                      return (
                        <div className={classes.provider} key={idx}>
                          <div className={classes.image}>
                            <img
                              src={`https://media.themoviedb.org/t/p/original/${dataItem?.logo_path}`}
                              alt={dataItem?.provider_name}
                              className={classes.provider_img}
                            />
                          </div>
                          <p className={classes.bio}>
                            {dataItem?.provider_name}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </motion.div>

        </>
      )}
    </>
  );
};

export default SeriesDetail;
